import { useCallback, useEffect, useState, useMemo } from 'react';
import PhotoSize from '@alltrails/types/PhotoSize';
import { getCardPhotoUrl } from '@alltrails/shared/utils/requests/photoRequests';

const useCardPhotos = (id: number, photoCount: number) => {
  const [photos, setPhotos] = useState<string[]>([]);
  const [photosLoaded, setPhotosLoaded] = useState(false);

  useEffect(() => {
    const initialPhoto = getCardPhotoUrl('maps', id, 0, PhotoSize.LargerWide, '');
    let fillerPhotos: string[] = [];
    if (photoCount > 1) {
      fillerPhotos = Array(photoCount - 1).fill('') as string[];
    }
    setPhotos([initialPhoto, ...fillerPhotos]);
    setPhotosLoaded(false);
  }, [id, photoCount]);

  const loadPhotos = useCallback(() => {
    if (!photosLoaded) {
      setPhotosLoaded(true);

      const urls = photos.map((_, index) => {
        const url = getCardPhotoUrl('maps', id, index, PhotoSize.LargerWide, '');
        // pre-load images by browser
        try {
          new Image().src = url;
        } catch {
          // silently catch
        }
        return url;
      });

      setPhotos(urls);
    }
  }, [id, photos, photosLoaded]);

  return useMemo(() => ({ photos, loadPhotos }), [photos, loadPhotos]);
};

export default useCardPhotos;
